export default __webpack_public_path__ + "static/media/arrow-up.45b4bf39.svg";